module.exports = __webpack_public_path__ + "img/stone-texture.ea20c885.jpg";